import { useZocksQuota } from '../../../components/ScopedBlock/hooks'

export const useCrossClientFundsQuotas = () => {
  const { quotas, isFetching } = useZocksQuota()
  const ai = quotas?.data?.ai

  const canStart = ai?.ccqStart?.value !== false
  const canLocalResolverEval = ai?.ccqLocalResolverStart?.value !== false
  const canAiEval = ai?.ccqAiEvalStart?.value !== false

  const quotaLoading = isFetching && !quotas?.data

  return { canStart, canLocalResolverEval, canAiEval, quotaLoading }
}
